import { TextField, MenuItem } from "@mui/material";
import React, { useRef } from "react";
import { Loader } from "../../assets/images/index";
import "./dropdown.scss";

interface DropdownOption {
  value: string | number;
  label: string;
  labelNode?: React.ReactNode;
}

interface DropdownProps {
  label: string;
  value: string | number | null;
  options: DropdownOption[];
  onChange: (value: string | number) => void;
  size?: "small" | "medium";
  disabled?: boolean;
  required?: boolean;
  loading?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({
  label,
  value,
  options,
  onChange,
  size = "small",
  disabled = false,
  required = false,
  loading = false,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const selectedOption = options.find(
    (opt) =>
      opt.value === value ||
      opt.value === String(value) ||
      (typeof opt.value === "number" && opt.value === Number(value))
  );
  const selectedLabel = selectedOption ? selectedOption.label : (typeof value === "string" ? value : "");

  const renderLabel = () => {
    if (!required) return label;
    return (
      <span>
        {label} <span className="required-asterisk">*</span>
      </span>
    );
  };

  return (
    <div ref={containerRef} className={`dropdown-container ${loading ? "loading" : ""}`}>
      <TextField
        select
        fullWidth
        label={renderLabel()}
        value={value ?? ""}
        onChange={(e) => {
          const selected = e.target.value;
          const isNumber = options.some(opt => typeof opt.value === "number");
          onChange(isNumber ? Number(selected) : selected);
        }}
        size={size}
        disabled={disabled || loading}
        className={`${disabled || loading ? "disabled-dropdown" : ""}`}
        SelectProps={{
          SelectDisplayProps: {
            title: selectedLabel,
          },
          MenuProps: {
            className: "dropdown-menu-root",
            PaperProps: {
              className: "dropdown-menu-paper",
              style: {
                width: containerRef.current?.clientWidth,
              },
            },
          },
        }}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value} title={opt.label}>
            {opt.labelNode ?? opt.label}
          </MenuItem>
        ))}
      </TextField>
      {loading && (
        <div className="loader-container">
          <img src={Loader} alt="loading" className="loader-icon" />
        </div>
      )}
    </div>
  );
};

export default Dropdown;
